import { memo, useCallback, useMemo } from 'react';
import { Button, Icon, Switch, Text, useTheme } from '@Sage/hoi-poi-ui';

import AutomationsHelpActions from 'components/AutomationsHelpActions';
import { getLiteral } from 'utils/getLiteral';

const AutomationBuilderToolbar = memo(({ enabled, onChange, onEditDetails }) => {
    const theme = useTheme();
    const showSupportChat = Boolean(window.Intercom);

    const onChangeEnabled = useCallback(
        (value) => {
            onChange('enabled', value);
        },
        [onChange],
    );

    const extraActions = useMemo(() => {
        if (!showSupportChat) return [];

        return [
            {
                icon: 'comment',
                label: getLiteral('action_support_chat'),
                onClick: () => window.Intercom('showNewMessage'),
            },
        ];
    }, [showSupportChat]);

    return (
        <div className="fm-automation-builder__toolbar">
            <div className="fm-automation-builders__toolbar-items">
                <div className="fm-automation-builder__toolbar-item">
                    <Button
                        icon="settings"
                        onClick={() => onEditDetails()}
                        size="small"
                        type="terciary"
                    >
                        {getLiteral('label_automation_edit_name')}
                    </Button>
                </div>
                <Icon name="verticalDivider" color={theme.colors.grey[100]} />
                <div className="fm-automation-builder__toolbar-item">
                    <Text>{getLiteral('label_active')}</Text>
                    <Switch checked={enabled} onChange={onChangeEnabled} size="medium" />
                </div>
            </div>
            <div className="fm-automation-builder__toolbar-helpers">
                <AutomationsHelpActions
                    extraActions={extraActions}
                    videoTutorialLabel={getLiteral('action_automations_video_tutorial')}
                    videoTutorialUrl={getLiteral('label_automations_video_tutorial_link')}
                    knowledgeMoreUrl={getLiteral('label_automations_knowledge_base_link')}
                />
            </div>
        </div>
    );
});

export default AutomationBuilderToolbar;
